module.exports = __webpack_public_path__ + "static/media/send.31fd6f72.svg";